import { useCallback } from "react";
import TagManager from "react-gtm-module";

export function useVirtualPVAnalyticsCall() {
  const analyticsCall = useCallback(
    (path: string, title: string, latlong: string) => {
      TagManager.dataLayer({
        dataLayer: {
          event: "bhVirtualPV",
          page_path: path,
          title: title,
          latlong: latlong,
        },
      });
    },
    [],
  );

  return analyticsCall;
}
